import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _isOpenMenu$ = new BehaviorSubject<boolean>(false);

  get isOpenMenu$(): Observable<boolean> {
    return this._isOpenMenu$.asObservable();
  }

  setMenuState(state: boolean) {
    this._isOpenMenu$.next(state);
  }
}
